export abstract class KeyValueStore {

  abstract putValue(key: string, value: string);

  abstract getValue(key: string): string | null;

  abstract clearValue(key: string);

}
